/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BUTTON_FORMAT_STRONG, BUTTON_THEME_PRIMARY, Divider, ICON_ADD_CIRCLE } from '@squiz/sds';
import React from 'react';
import { CreateToolDialog } from '../../Components/CreateToolDialog/CreateToolDialog';
import { CreateToolDialogProps } from '../CreateToolDialog/CreateToolDialog.props';
import { AiScreenBannerProps } from './AiScreenBanner.props';

/**
 * The banner for AI screens.
 */
export const AiScreenBanner = (props: AiScreenBannerProps): JSX.Element => {
  const { aiType, description } = props;

  const dialogProps: CreateToolDialogProps = {
    buttonProps: {
      dataId: 'create-chatbot-button',
      format: BUTTON_FORMAT_STRONG,
      icon: ICON_ADD_CIRCLE,
      theme: BUTTON_THEME_PRIMARY,
    },
    type: aiType,
  };

  return (
    <>
      <div className="ai-screen-banner" data-id="AI Screen Banner">
        <p>{description}</p>
        <CreateToolDialog {...dialogProps}></CreateToolDialog>
      </div>
      <Divider />
    </>
  );
};
